import { RemoveJobStore } from "@domain/stores/RemoveJobStore";
import { create } from "zustand";

type InitialState = Pick<RemoveJobStore, "removeJob">;

const initialState: InitialState = {
  removeJob: null,
};

const removeJobStore = create<RemoveJobStore>((set) => ({
  ...initialState,
  updateRemoveJob(newRemoveJob) {
    set((state) => {
      return {
        ...state,
        removeJob: newRemoveJob,
      };
    });
  },
  clear: () => {
    set((state) => {
      return {
        ...state,
        ...initialState,
      };
    });
  },
}));

export default removeJobStore;
